// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"593":"00d4510f","789":"eb4b1b6b","844":"1c0f2415"}[chunkId] + ".chunk.css";
};